import { useTranslation } from "react-i18next"
import { getStatus } from "../../../../../../../../../hooks/status"
import { useContextState } from "../../../../../../../../../hooks/theme"
import { Roles, Status, Types } from "../../../../../../../../../utils/enums"
import { useEffect, useMemo, useRef, useState } from "react"
import dayjs, { Dayjs } from "dayjs"
import { DataActivityForm, Destination, Local, LocalStorageData, TypeOfActivity } from "../../create/types"
import { DestinationType } from "../../create/enums/destinationType"
import { InputModel, Table } from "../../../../../../../../../utils/types"
import { Box, Radio, Typography } from "@mui/material"
import { useStyles } from "../styles"
import { getLocalStorage } from "../../../../../../../../../utils/crud/crypt"
import { getRoles } from "../../../../../../../../../utils/methods/geServiceWithItemsFormat"
import { loogbookServiceFetch, userServiceFetch } from "../../../../../../../../../utils/constants/callService"
import { returnQuery } from "../../../../../../../../../utils/methods/returnQuery"
import { formatActivityDataResponse, formatUsersDataListResponse, formatUsersDataUnitsResponse } from "../../../../../../../../../service/logbook/format/activity"
import { FilterBody } from "../../../../../../../../../hooks/filter/typing"
import { UserData } from "../types"
import { EvidenceDataHook } from "../../../../../../../../../hooks/evidences/typyng"
import { questiononEvidencesToEvidenceData } from "../../../../../../../../../service/logbook/format"
import { generalDisabled } from "../../../../../../../../../utils/validate/validate"
import { formatBodyToEditActivity } from "../../../../../../../../../service/logbook/body"
import { Evidence } from "../../../../../../../../../service/logbook/response"
import { FormatEvidenceData } from "../../../../../../../../../components/uploadEvidence/contants"
import { useEvidences } from "../../../../../../../../../hooks/evidences/useEvidences"
import { useUploadEvidence } from "../../../../../../../../../components/uploadEvidence/hooks"
import { Navigate, useLocation, useNavigate } from "react-router-dom"
import { GetEvidencePayload } from "../../../detailHeader/types"
import { formatEvidencesToSendBody } from "../../../../../../../../../components/uploadEvidence/methods"



const useBody = (
  filterUnity: FilterBody,
  formatFilterUnity: Record<string, string>,
  filter: FilterBody,
  handleDataActivity: (data?: DataActivityForm) => void,
  formatFilter: Record<string, string>,
  dataActivity: DataActivityForm | undefined,
  inputActivity: { [x: string]: InputModel; },
  inputSecondActivity: { [x: string]: InputModel; },
  inputLastActivity: { [x: string]: InputModel; }
) => {

  const { t } = useTranslation()
  const styles = useStyles()
  const { colors } = useContextState()

  const [status, setSatus] = useState<Status>(Status.ACTIVE)
  const navigate = useNavigate()
  const localStorage = getLocalStorage() as LocalStorageData;
  const isPartner = localStorage.role == Roles.PARTNER
  const [isFree, setIsFree] = useState(false)
  const [flagToChangeActivity, setFlagToChangeActivity] = useState(false)
  const [currentActivity, setCurrentActivity] = useState<TypeOfActivity | undefined>(undefined)
  /* const [evidencesArray, setEvidencesArray] = useState<Evidence[] | undefined>(undefined) */
  const [configEvidences, setConfigEvidences] = useState<FormatEvidenceData>()
  const [errors, setErrors] = useState<Record<string, string>>({})
  const [oldTypeDestination, setOldTypeDestination] = useState<DestinationType>()
  const statusLocale = getStatus(status, colors, t)
  const [edit, setEdit] = useState(false)
  const [totalPages, setTotalPages] = useState(0)
  const refTime = useRef<NodeJS.Timeout | null>(null)
  const refTimeSecond = useRef<NodeJS.Timeout | null>(null)
  const [destination, setDestination] = useState<Destination | undefined>(undefined)
  const [destinationFinal, setDestinationFinal] = useState<Destination | undefined>(/* undefined */{ id: 1, latitude: 37.77934726587506, longitude: -122.42729642333984, name: 'aa', type: DestinationType.DESTINATION })
  const [user, setUser] = useState<UserData | undefined>(undefined)
  const [userFinal, setUserFinal] = useState<UserData | undefined>(undefined)
  const disableActivityForm = useMemo(() => generalDisabled(inputActivity, dataActivity), [dataActivity])
  const disableActivityFormSecond = useMemo(() => generalDisabled(inputSecondActivity, dataActivity), [dataActivity])
  const disableActivityFormLast = useMemo(() => generalDisabled(inputLastActivity, dataActivity), [dataActivity, inputLastActivity])
  const [defaultValues, setDefaultValues] = useState<{ from?: Dayjs; to?: Dayjs; }>({ from: dayjs(), to: null });
  const [isToBiggerThanFrom, setIsToBiggerThanFrom] = useState(dayjs(defaultValues.to).date() > dayjs(defaultValues.from).date())
  const [openModal, setOpenModal] = useState<{
    open: boolean;
    title?: string;
    description?: string;
    confirm?: () => void;
    cancel?: () => void;
  }>({ open: false })
  const [countOfEvidences, setCountOfEvidences] = useState(0)
  const getDate = (date: Dayjs, name: 'to' | 'from') => {
    setDefaultValues(prev => ({ ...prev, [name]: date }))
  }
  const [geofence, setGeofence] = useState(false)
  const [loading, setLoading] = useState({
    users: false,
    activityByUser: false,
    units: false,
    activityData: false,
    editActivity: false
  })
  const location = useLocation()
  const [_, activityId] = location.hash.split('-') ?? []

  const [snackbar, setSnackbar] = useState({
    open: false,
    type: Types.SUCCESS,
    message: '',
  })

  const evidenceUpload = useUploadEvidence()
  const { evidences, existEvidences, manageData } = useEvidences({ evidencesResponse: [], manualValue: true })

  const columnUnits = [
    {
      id: 'id',
      label: t('general.tags.id'),
      sortable: true,
    },
    {
      id: 'divisionDescription',
      label: t('general.tags.division'),
      sortable: true,
    },
    {
      id: 'zoneName',
      label: t('general.tags.zone'),
      sortable: true,
    },
    {
      id: 'name',
      label: t('general.tags.store_name'),
      sortable: true,
    },
  ]

  const columnUsers = [
    {
      id: 'curp',
      label: t('general.tags.curp'),
      sortable: true,
    },
    {
      id: 'firstName',
      label: t('general.tags.name'),
      sortable: true,
    },
    {
      id: 'lastName',
      label: t('general.tags.lastName'),
      sortable: true,
    },
    {
      id: 'gender',
      label: t('general.tags.gender'),
      sortable: true,
      renderCell: (params: any) => {
        const gender = params.row?.gender
        return (
          <Typography sx={styles.user} className="w-full">
            {t(`general.fields.gender.${gender > 1 ? '3' : gender + 1}`)}
          </Typography>
        )
      },
    },
    {
      id: 'role',
      label: t('general.tags.role'),
      sortable: true,
      renderCell: (params: any) => {
        const role = params.row?.role.description
        return (
          <Box >
            {!!role ? (
              <>
                {!!role && (
                  <Typography sx={styles.user} className="w-full">
                    {role}
                  </Typography>
                )}
              </>
            ) : (
              <Typography sx={styles.user} className="w-full">
                {'N/A'}
              </Typography>
            )}
          </Box>
        )
      },
    },
    {
      id: 'userTypeDescription',
      label: t('general.tags.userType'),
      sortable: true,
    },
  ]

  const [tableUnits, setTableUnits] = useState<Table>({ column: columnUnits, row: [] })
  const [tableUsers, setTableUsers] = useState<Table>({ column: columnUsers, row: [] })

  const setUnityToDestination = () => {
    setDestinationFinal(destination)
  }

  const setUserToFinal = () => {
    setUserFinal(user)
  }

  const getUnits = async () => {

    setLoading(prev => ({
      ...prev,
      units: true
    }))

    let asociate;
    let companyId;

    const company: Local = getLocalStorage()

    if (company.role == Roles.ADMIN) {
      asociate = false;
      companyId = null;
    } else {
      asociate = filterUnity.filterData.onlyHierarchy;
      companyId = company.company?.id;
    }

    const response = await loogbookServiceFetch.getUnits({ query: returnQuery({ ...filterUnity.query, filter: filterUnity.query.filter?.replaceAll('+', '%2B') }, formatFilterUnity), asociate: asociate, companyId: companyId })

    const { row, totalPages } = formatUsersDataUnitsResponse({ response })

    setTableUnits((prev) => ({ ...prev, row: row }))
    setTotalPages(totalPages)

    setLoading(prev => ({
      ...prev,
      units: false
    }))
  }

  const closeModal = () => {
    setOpenModal((prev) => ({ ...prev, open: false }));
  };

  const handleRowClickUser = (index: number | string) => {

    const clickedRow = tableUsers.row.find(row => row.id === index); // Acceder a la fila solo si index es un número.

    setUser(
      {
        id: clickedRow.id,
        area: clickedRow.area,
        department: clickedRow.department,
        division: clickedRow.division ? clickedRow.division.description : undefined,
        role: clickedRow.role.description,
        name: `${clickedRow.firstName} ${clickedRow.lastName}`
      });

  };

  const handleRowClickUnity = (index: number | string) => {

    const clickedRow = tableUnits.row.find(row => row.id === index);

    setDestination(
      {
        latitude: clickedRow.latitude,
        longitude: clickedRow.longitude,
        name: clickedRow.name,
        type: DestinationType.UNITY,
        id: clickedRow.id,
        timeZone: clickedRow.storeTimeZone
      });

  };

  const getActivityData = async () => {

    setLoading(prev => ({
      ...prev,
      activityData: true
    }))


    const response = await loogbookServiceFetch.getDataActivity({ id: Number(activityId) })

    const { status, user, activity, evidences, generalConfig, geofence, activityWithoutUser, isFree } = formatActivityDataResponse({ response })

    manageData({ evidencesResponse: evidences })
    setIsFree(isFree)
    setCountOfEvidences(evidences?.length ?? 0)
    setSatus(status)
    setConfigEvidences(generalConfig)
    setGeofence(geofence)
    setUserFinal(user)

    if (!geofence && activity) {
      handleDataActivity({
        observation: activity.observation,
        title: activity.name,
        open: activity.activityTypeText,
        typeOfActivity: activity.type ? {
          label: activity.type.label ?? '',
          value: Number(activity.type.value),
          configTypeActivityEvidence: generalConfig,
          openField: activity.type.openField
        } : undefined
      })

      setDestinationFinal({
        id: activity.destination.id,
        latitude: activity.destination.latitude,
        longitude: activity.destination.longitude,
        name: activity.destination.name,
        type: activity.destination.type,
        timeZone: activity.destination.timeZone
      })

      setDefaultValues({
        from: activity.startDate ? activity.startDate : activity.destination.timeZone ? dayjs().tz(activity.destination.timeZone.code) : dayjs(),
        to: activity.endDate ? activity.endDate : null
      })
    } else {
      if (activityWithoutUser) {
        handleDataActivity({
          observation: activityWithoutUser.observation,
          title: activityWithoutUser.name,
          open: activityWithoutUser.activityTypeText,
          typeOfActivity: activityWithoutUser.type ? {
            label: activityWithoutUser.type.label ?? '',
            value: Number(activityWithoutUser.type.value),
            configTypeActivityEvidence: generalConfig,
            openField: activityWithoutUser.type.openField
          } : undefined
        })
      }
    }

    setLoading(prev => ({
      ...prev,
      activityData: false
    }))

  }

  const getUsersList = async () => {

    setLoading(prev => ({
      ...prev,
      users: true
    }))

    const response = await loogbookServiceFetch.getUsersData({ query: returnQuery({ ...filter.query, filter: filter.query.filter?.replaceAll('+', '%2B') }, formatFilter) })

    const { row } = formatUsersDataListResponse({ response })

    setTableUsers((prev) => ({ ...prev, row: row }))

    setLoading(prev => ({
      ...prev,
      users: false
    }))
  }

  const handleCancelEdit = () => {
    setOpenModal((prev) => ({
      ...prev,
      open: true,
      title: t('loogbook.modal.cancelEdit'),
      description: t('loogbook.modal.cancelEditDescription'),
      confirm: () => {
        /* if(isPartner){ */
        navigate(`/dashboard/logbook#`)
        /* } else{
          window.location.hash = ''
        } */
      }
    }));
  }

  const handleSubmitActivity = async () => {
    setLoading(prev => ({
      ...prev,
      editActivity: true
    }))
    const { body } = formatBodyToEditActivity({ isFree: isFree, statusId: status ,userFinal, destinationFinal, dataActivity, defaultValues, evidences, geofence })
    const response = await loogbookServiceFetch.updateActivityById(body, Number(activityId))

    if (response.errors) {
      setSnackbar({ message: t('loogbook.snackbar.editActivity.error'), open: true, type: Types.ERROR })
    } else {
      setSnackbar({ message: t('loogbook.snackbar.editActivity.success'), open: true, type: Types.SUCCESS })
      setTimeout(() => {
        window.location.hash = "";
      }, 1500);
    }

    setLoading(prev => ({
      ...prev,
      editActivity: false
    }))
  }

  const submitEvidences = async ({ evidences }: GetEvidencePayload) => {
    const someIsRequired = evidenceUpload.someEvidenceIsRequired()
    const thereAreSomeChange = evidenceUpload.hasAnyValueChanged()
    /* if (someIsRequired) {
      setSnackbar({ message: t('loogbook.snackbar.requiredFields'), open: true, type: Types.ERROR })
      return
    } */
    if (!thereAreSomeChange) {
      setSnackbar({ message: t('loogbook.snackbar.thereAreNotSomeChange'), open: true, type: Types.ERROR })
      return
    }
    if (!someIsRequired && !!thereAreSomeChange) {
      const convert = formatEvidencesToSendBody({ evidences })
      manageData({ evidencesResponse: convert.evidences })
      evidenceUpload.deleteListOfFiles()
      setCountOfEvidences(convert.evidences.length)
      //setSnackbar({ message: t('loogbook.snackbar.evidenceActivity.success'), open: true, type: Types.SUCCESS })
      //closeModal()
      /* 
      const body: EvidenceActivityBody = {
          ...convert,
          id: activityId
      }
      const response = await loogbookServiceFetch.evidencesActivity({ body })
      if (!response.errors) {
          getActivity()
          evidenceUpload.deleteListOfFiles()
          closeModal()
          setSnackbar({ message: t('loogbook.snackbar.evidenceActivity.success'), open: true, type: Types.SUCCESS })
          return
      }
      setSnackbar({ message: handleAllErrors(response?.errors?.[0]?.code, t, 'loogbook.snackbar.evidenceActivity.error'), open: true, type: Types.ERROR }) */
    }
  }

  const closeSnackbar = () => {
    setSnackbar(prev => ({ ...prev, open: false }))
  }

  useEffect(() => {
    getUsersList()
  }, [filter.query.all])

  useEffect(() => {
    getActivityData()
  }, [])

  useEffect(() => {

    if (refTime.current) { clearTimeout(refTime.current) }
    refTime.current = setTimeout(() => {
      getUnits()
    }, 300)

  }, [filterUnity.query.all])

  useEffect(() => {

    if (refTimeSecond.current) { clearTimeout(refTimeSecond.current) }
    refTimeSecond.current = setTimeout(() => {
      getUsersList()
    }, 300)

  }, [filter.query.all])

  useEffect(() => {

    if (!!dataActivity?.typeOfActivity) {
      if (dataActivity.typeOfActivity.value !== currentActivity?.value) {
        const { typeOfActivity, ...rest } = dataActivity;
        if (!currentActivity) {
          //consol
          setConfigEvidences(typeOfActivity.configTypeActivityEvidence);
          setCurrentActivity(typeOfActivity)
        } else {
          if (existEvidences) {
            setOpenModal((prev) => ({
              ...prev,
              open: true,
              title: t('loogbook.modal.changeActivityType'),
              description: t('loogbook.modal.changeActivityTypeDescription'),
              confirm: () => {
                setConfigEvidences(typeOfActivity.configTypeActivityEvidence);
                setCurrentActivity(typeOfActivity)
                manageData({ evidencesResponse: [] })
                closeModal()
              },
              cancel: () => {
                handleDataActivity({
                  observation: dataActivity.observation,
                  title: dataActivity.title,
                  typeOfActivity: currentActivity
                })
                //setCurrentActivity(currentActivity)
                closeModal()
              }
            }));
          } else {
            setConfigEvidences(typeOfActivity.configTypeActivityEvidence);
            setCurrentActivity(typeOfActivity)
          }
        }
      }
    } else {

      if (existEvidences) {
        setOpenModal((prev) => ({
          ...prev,
          open: true,
          title: t('loogbook.modal.deleteActivityType'),
          description: t('loogbook.modal.deleteActivityTypeDescription'),
          confirm: () => {
            setCurrentActivity(undefined)
            setCountOfEvidences(0)
            //setConfigEvidences(typeOfActivity.configTypeActivityEvidence);
            manageData({ evidencesResponse: [] })
            closeModal()
          },
          cancel: () => {
            handleDataActivity({
              observation: dataActivity?.observation,
              title: dataActivity?.title,
              typeOfActivity: currentActivity
            })
            //setCurrentActivity(currentActivity)
            closeModal()
          }
        }));
      } else {
        //setConfigEvidences(typeOfActivity.configTypeActivityEvidence);
        setCurrentActivity(undefined)
        setCountOfEvidences(0)
      }


    }

    /* if (!!dataActivity?.typeOfActivity) {
      const { typeOfActivity, ...rest } = dataActivity;

      if(idCurrentActivity==typeOfActivity.value){
      }

      if(flagToChangeActivity){
        setConfigEvidences(typeOfActivity.configTypeActivityEvidence);
      }

    } */
  }, [dataActivity?.typeOfActivity]) //idCurrentActivity


  return {
    statusLocale,
    user,
    status,
    configEvidences,
    openModal,
    /* evidencesArray, */
    handleCancelEdit,
    closeModal,
    disableActivityForm,
    edit,
    setEdit,
    handleRowClickUnity,
    handleRowClickUser,
    userFinal,
    setUserFinal,
    setUser,
    setUserToFinal,
    setUnityToDestination,
    tableUsers,
    loading,
    totalPages,
    setDestinationFinal,
    setDestination,
    defaultValues,
    isToBiggerThanFrom,
    getDate,
    setIsToBiggerThanFrom,
    destinationFinal,
    tableUnits,
    destination,
    setDefaultValues,
    closeSnackbar,
    snackbar,
    activityId,
    submitEvidences,
    existEvidences,
    evidences,
    evidenceUpload,
    countOfEvidences,
    errors,
    setErrors,
    handleSubmitActivity,
    setOldTypeDestination,
    oldTypeDestination,
    disableActivityFormLast,
    disableActivityFormSecond,
    geofence,
    isFree,
    isPartner
  }
}

export { useBody }